import {
    openModal,
    closeModal,
} from '../../../../assets/src/js/common/modals';

import '../sass/single-gallery-content.scss';

(() => {
    const $singleGalleryContentTemplateParts = document.querySelectorAll('.single-gallery-content');

    if (!$singleGalleryContentTemplateParts) return;

    $singleGalleryContentTemplateParts.forEach(($singleGalleryContent) => {
        let carousel = null;
        let carouselNav = null;
        let allowCarouselChangeEvent = true;
        let allowModalCloseEvent = true;

        const $galleryCardLinks = $singleGalleryContent.querySelectorAll('.gallery-card__inner');
        const $modal = $singleGalleryContent.querySelector('.single-gallery-content__modal');
        const $modalPlayButton = $singleGalleryContent.querySelector('.single-gallery-content__modal-play-button');
        const $modalMaximiseButton = $singleGalleryContent.querySelector('.single-gallery-content__modal-maximise-button');
        const $modalDownloadButton = $singleGalleryContent.querySelector('.single-gallery-content__modal-download-button');
        const $carousel = $singleGalleryContent.querySelector('.single-gallery-content__carousel');
        const $carouselSlides = $singleGalleryContent.querySelectorAll('.single-gallery-content__carousel-slide');
        const $carouselControlsPrev = $singleGalleryContent.querySelector('.single-gallery-content__carousel-controls-prev');
        const $carouselControlsNext = $singleGalleryContent.querySelector('.single-gallery-content__carousel-controls-next');
        const $modalCounterCurrent = $singleGalleryContent.querySelector('.single-gallery-content__modal-counter-current');
        const $modalBottom = $singleGalleryContent.querySelector('.single-gallery-content__modal-bottom');
        const $carouselNav = $singleGalleryContent.querySelector('.single-gallery-content__carousel-nav');
        const $carouselNavSlides = $singleGalleryContent.querySelectorAll('.single-gallery-content__carousel-nav-slide');
        const $carouselNavButtons = $singleGalleryContent.querySelectorAll('.single-gallery-content__carousel-nav-slide-button');
        const $carouselNavToggle = $singleGalleryContent.querySelector('.single-gallery-content__carousel-nav-toggle');

        const initModal = () => {
            if (!$modal) return;

            $modal.addEventListener('modalclose', () => {
                if (document.fullscreenElement && document.exitFullscreen) {
                    document.exitFullscreen();
                }
            });
        };

        const initCarousel = () => {
            if (!$carousel) return;

            const { initialSlideIndex } = $carousel.dataset;

            carousel = new Swiper($carousel, {
                initialSlide: initialSlideIndex,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                navigation: {
                    nextEl: $carouselControlsNext,
                    prevEl: $carouselControlsPrev,
                },
            });

            carousel.on('realIndexChange', swiper => {
                const index = !isNaN(swiper?.realIndex) ? swiper.realIndex : 0;

                if ($modalCounterCurrent) {
                    $modalCounterCurrent.innerHTML = index + 1;
                }

                const { mediaId, imageUrl } = $carouselSlides?.[index]?.dataset;

                if ($modalDownloadButton) {
                    $modalDownloadButton.href = imageUrl ?? '';
                }

                const $activeCarouselNavSlide = $singleGalleryContent.querySelector('.single-gallery-content__carousel-nav-slide--active');

                if ($activeCarouselNavSlide) $activeCarouselNavSlide.classList.remove('single-gallery-content__carousel-nav-slide--active');

                if ($carouselNavSlides?.[index]) {
                    $carouselNavSlides[index].classList.add('single-gallery-content__carousel-nav-slide--active');
                }

                if (!allowCarouselChangeEvent) return;

                if (!mediaId) return;

                const url = new URL(window.location.href);
                const urlParams = new URLSearchParams(url.search);

                if ($modal.classList.contains('modal--active')) {
                    urlParams.set('media_id', mediaId);

                    window.history.replaceState({
                        url: url?.origin + url?.pathname + '?' + urlParams.toString(),
                    }, '', url?.origin + url?.pathname + '?' + urlParams.toString());
                }
            });

            if ($carouselNav) {
                carouselNav = new Swiper($carouselNav, {
                    initialSlide: initialSlideIndex,
                    slidesPerView: 'auto',
                    spaceBetween: 5,
                });
            }

            if ($carouselNavButtons) {
                $carouselNavButtons.forEach($carouselNavButton => {
                    $carouselNavButton.addEventListener('click', () => {
                        const { slideIndex } = $carouselNavButton.dataset;

                        carousel.slideTo(slideIndex);
                    });
                })
            }

            if ($modalPlayButton) {
                $modalPlayButton.addEventListener('click', () => {
                    if (carousel?.autoplay?.running) {
                        carousel.autoplay.stop();
                    } else {
                        carousel.autoplay.start();
                    }
                });

                carousel.on('autoplayStart', () => {
                    $modalPlayButton.classList.add('single-gallery-content__modal-play-button--playing');
                });
    
                carousel.on('autoplayStop', () => {
                    $modalPlayButton.classList.remove('single-gallery-content__modal-play-button--playing');
                });
            }

            if ($modalMaximiseButton) {
                $modalMaximiseButton.addEventListener('click', () => {
                    if (!document.fullscreenElement && $modal.requestFullscreen) {
                        $modal.requestFullscreen();
                    }

                    if (document.fullscreenElement && document.exitFullscreen) {
                        document.exitFullscreen();
                    }
                });

                $modal.addEventListener('fullscreenchange', e => {
                    if (document.fullscreenElement === $modal) {
                        $modalMaximiseButton.classList.add('single-gallery-content__modal-maximise-button--maximised');
                    } else {
                        $modalMaximiseButton.classList.remove('single-gallery-content__modal-maximise-button--maximised');
                    }
                });
            }

            if ($carouselNavToggle) {
                $carouselNavToggle.addEventListener('click', () => {
                    if ($modalBottom.classList.contains('single-gallery-content__modal-bottom--hidden')) {
                        $modalBottom.style.height = '0px';

                        window.requestAnimationFrame(() => {
                            $modalBottom.classList.remove('single-gallery-content__modal-bottom--hidden');

                            $modalBottom.style.height = `${$modalBottom.scrollHeight}px`;

                            setTimeout(() => {
                                $modalBottom.style.height = '';
                            }, 300);
                        });
                    } else {
                        $modalBottom.style.height = `${$modalBottom.scrollHeight}px`;

                        window.requestAnimationFrame(() => {
                            $modalBottom.classList.add('single-gallery-content__modal-bottom--hidden');

                            $modalBottom.style.height = '0';

                            setTimeout(() => {
                                $modalBottom.style.height = '';
                            }, 300);
                        });
                    }
                });
            }
        };

        const initGalleryCardLinks = () => {
            if (!$galleryCardLinks || !$modal) return;

            $galleryCardLinks.forEach($galleryCardLink => {
                $galleryCardLink.addEventListener('click', e => {
                    e.preventDefault();

                    const { slideIndex } = $galleryCardLink.dataset;

                    allowCarouselChangeEvent = false;

                    carousel?.slideTo(slideIndex, 0, false);
                
                    allowCarouselChangeEvent = true;

                    window.history.pushState({
                        url: $galleryCardLink?.href,
                    }, '', $galleryCardLink?.href);

                    openModal($modal);
                });
            });
        };

        const setInitialState = () => {
            const url = new URL(window.location.href);
            const urlParams = new URLSearchParams(url.search);

            if (urlParams.get('media_id')) {
                window.history.replaceState({
                    url: window.location.href,
                }, '', window.location.href);
            } else {
                window.history.replaceState({
                    url: window.location.href,
                }, '', window.location.href);
            }
        };

        window.addEventListener('popstate', e => {
            if (!carousel || !$modal || !e.state?.url) return;

            const url = new URL(e.state.url);
            const urlParams = new URLSearchParams(url.search);

            const mediaId = urlParams.get('media_id');

            if (mediaId) {
                const $carouselSlide = $singleGalleryContent.querySelector('.single-gallery-content__carousel-slide[data-media-id="' + mediaId + '"]');

                if (!$carouselSlide) return;
                
                const { slideIndex } = $carouselSlide?.dataset;

                if (!slideIndex) return;

                carousel?.slideTo(slideIndex, 0, false);
            
                openModal($modal);
            } else {
                allowModalCloseEvent = false;
                closeModal($modal);
                allowModalCloseEvent = true;
            }
        });

        $modal?.addEventListener('modalclose', () => {
            if (!allowModalCloseEvent) return;

            const page = $modal?.dataset?.page ? parseInt($modal.dataset.page) : 1;

            window.history.pushState({
                url: window.location.origin + window.location.pathname,
            }, '', window.location.origin + window.location.pathname + (page > 1 ? '?gallery_page=' + page : ''));
        });

        initModal();
        initCarousel();
        initGalleryCardLinks();
        setInitialState();
    });
})();
